/** Комментарии сотрудников к строке таблицы: видны сразу, добавляются прямо в ячейке. */
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { shortTime } from "@/lib/leads";

export type Comment = { id: number; at: string; user_id: number; user: string; text: string };

export function Comments({
  list,
  add,
  onSaved,
  placeholder = "что сделали… Enter — сохранить",
  annot,
}: {
  list: Comment[];
  /** Сохранить текст; ответ — все комментарии объекта. */
  add: (text: string) => Promise<Comment[]>;
  onSaved: (list: Comment[]) => void;
  placeholder?: string;
  annot?: string;
}) {
  const [edit, setEdit] = useState(false);
  const [draft, setDraft] = useState("");
  const save = useMutation({
    mutationFn: () => add(draft.trim()),
    onSuccess: (next) => {
      onSaved(next);
      setDraft("");
      setEdit(false);
    },
  });
  const submit = () => {
    if (draft.trim() && !save.isPending) save.mutate();
  };
  return (
    <div
      className={`flex flex-col gap-1 ${list.length || edit ? "w-[260px]" : "w-max"}`}
      onClick={(e) => e.stopPropagation()}
    >
      {list.map((c) => (
        <div key={c.id} className="rounded-[var(--radius-ui)] bg-accent-dim px-2 py-1">
          <div className="whitespace-pre-wrap break-words">{c.text}</div>
          <div className="text-[11px] text-fg-faint">
            {c.user} · {shortTime(c.at)}
          </div>
        </div>
      ))}
      {edit ? (
        <div className="flex flex-col gap-1">
          <textarea
            autoFocus
            rows={2}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                submit();
              } else if (e.key === "Escape") setEdit(false);
            }}
            placeholder={placeholder}
            className="w-full resize-y rounded-[var(--radius-ui)] border border-border bg-bg px-2 py-1 text-[12.5px] outline-none focus:border-accent"
          />
          <div className="flex items-center gap-2 text-[12px]">
            <button
              type="button"
              onClick={submit}
              disabled={!draft.trim() || save.isPending}
              className="h-6 rounded-[var(--radius-ui)] border border-accent px-2 text-accent-text disabled:opacity-50"
            >
              {save.isPending ? "Сохраняю…" : "Сохранить"}
            </button>
            <button type="button" onClick={() => setEdit(false)} className="text-fg-muted hover:text-fg">
              отмена
            </button>
            {save.isError && <span className="text-err">{String(save.error.message)}</span>}
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setEdit(true)}
          className="self-start text-[12px] text-fg-faint hover:text-accent-text"
          data-annot={annot}
        >
          + комментарий
        </button>
      )}
    </div>
  );
}
